module.exports = __webpack_public_path__ + "img/cta-section-image01.61d93d85.png";